import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'eyewash_stations_showers_do_not_use_potable_water'

export const dataPointDefinition = {
  retracedId: 'eyewash_stations_showers_do_not_use_potable_water',
  name: 'Eyewash stations or showers do not use potable water at the right temperature and pressure',
  description:
    'Potable water at the right temperature means temperature between 16-38�C (60-100�F). And at right pressure means that water flow is kept constant through flow meters, and other devices. The ideal pressure for a shower or eyewash is between 30 and 90 psi.',
  meta: {
    slcpMeta: {
      key: 'hs-che-40x',
      number: 'HS-CHE-15-4',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'hs-che-40x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 30290,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
